// @flow

export const DEBOUNCE_DELAY_TIME = 500;
